import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import './card-caption.sass'

/* eslint-disable */
const CardCaption = ({bsSize='', iconId=1, children}) => (
  <div className={`card-caption card-caption-${bsSize}`}>
    <div className="card-caption__img-wrapper">
      <Icon type={iconId} />
    </div>
    <h4 className="card-caption__name">{children}</h4>
  </div>
)

CardCaption.propTypes = {
  children: PropTypes.node.isRequired,
  bsSize: PropTypes.string
}

CardCaption.defaultProps = {
  iconId: 1,
  bsSize: ''
}

export default CardCaption



// WEBPACK FOOTER //
// ./components/CardCaption/index.jsx